import React, { useEffect,useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {useNavigate } from 'react-router-dom';
import { getGroups, deleteGroup } from '../../../store/groups/actions';
import { DeleteConfrimationModal } from '../../../components/admin/DeleteConfirmation'
function Groups() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAdmin } = useSelector((state) => state.auth);
    const { groupList } = useSelector(state => state.grouplists);
    const [filter, setFilter] = useState({ sort: 2 });
    const [groupModal, setGroupEvent] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        dispatch(getGroups(filter));
    }, [filter]);

    const handleDeleteTrigger = (id, title) => {
        setGroupEvent({ id: id, title: title });
        setShowDeleteModal(true);
    }
    const handleDeleteEvent = (item) => {
        dispatch(deleteGroup(item.id));
    }

    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDeleteEvent={handleDeleteEvent}
                model={groupModal}
            />

            <div className="admin-page-wrap group-page-wrapper">
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content admin-body-wrap">
                        <div className="admin-page-title-wrap justify-content-between">
                            <h1 className="admin-page-heading m-0">Saved Groups</h1>
                            {isAdmin && <button className="admin-button create-outline-btn"
                                onClick={() =>
                                    navigate('/groups/patientgroup')
                                }
                            >
                                <span>Create Group</span>
                                <span className="material-symbols-rounded">add</span>
                            </button>}                            
                        </div>

                        <div className="pt">
                            <table className="admin-table">
                                <tbody>
                                    <tr>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Group Name</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 4 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}># of People in Group</th>
                                        <th className="admin-table-action-cell action-heading">&nbsp;</th>
                                    </tr>
                                    {groupList && groupList.length > 0 ? (
                                        groupList.map(item => (
                                            <tr key={item?.id}>
                                                <td className="admin-table-name-cell" align="middle">
                                                    <strong>
                                                        {item?.name}
                                                    </strong>
                                                </td>
                                                <td className="admin-table-name-cell text-right">{item?.recordCount}</td>
                                                <td className="admin-table-name-cell">
                                                    <div className="flex-center justify-end">
                                                        <button className="admin-table-action action-icon" onClick={() => navigate('/groups/patientgroup/' + item?.id)}>
                                                            <span className="material-symbols-outlined color-black">
                                                                {isAdmin ? 'edit' : 'visibility'}
                                                            </span>
                                                        </button>
                                                        {isAdmin && <button className="admin-table-action action-icon" onClick={() => handleDeleteTrigger(item?.id, item?.name)}>
                                                            <span className="material-symbols-outlined color-black">
                                                                delete
                                                            </span>
                                                        </button>}
                                                        
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="admin-table-name-cell" colSpan="4">No active group</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default Groups;